export default "__VITE_ASSET__DjpJ$Rnh__"